// src/beacon.ts
function isLocalhostHost(hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0" || hostname === "::1" || hostname === "[::1]" || hostname === "" || hostname.endsWith(".local") || hostname.endsWith(".localhost");
}
async function sendBeacon(endpoint, payload) {
  const body = JSON.stringify(payload);
  try {
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "text/plain" });
      if (navigator.sendBeacon(endpoint, blob)) return true;
    }
  } catch {
  }
  try {
    const res = await fetch(endpoint, {
      method: "POST",
      body,
      keepalive: true,
      mode: "cors",
      headers: { "Content-Type": "text/plain" }
    });
    return res.ok;
  } catch {
    return false;
  }
}

// src/core.ts
var cfg = null;
var lastPath = null;
var historyPatched = false;
var isBrowser = () => typeof window !== "undefined" && typeof navigator !== "undefined";
function isLocalhost() {
  return isLocalhostHost(window.location.hostname);
}
function domain() {
  return cfg?.domain || window.location.hostname;
}
function currentPath() {
  const { pathname, search, hash } = window.location;
  if (cfg?.hashRouting) {
    const h = hash.replace(/^#/, "") || "/";
    return cfg.includeQuery ? h : h.split("?")[0];
  }
  return cfg?.includeQuery ? pathname + search : pathname;
}
function post(payload) {
  void sendBeacon(cfg.endpoint, payload);
}
function pageview(path) {
  if (!cfg || !isBrowser()) return;
  const u = path ?? currentPath();
  if (u === lastPath) return;
  lastPath = u;
  post({
    n: "pageview",
    d: domain(),
    u,
    r: document.referrer || void 0,
    w: window.screen?.width
  });
}
function track(name, props) {
  if (!cfg || !isBrowser()) return;
  post({ n: name, d: domain(), u: currentPath(), p: props });
}
function wrap(method) {
  const original = window.history[method];
  window.history[method] = function(...args) {
    original.apply(this, args);
    pageview();
  };
}
function enableAutoPageviews() {
  if (historyPatched) return;
  historyPatched = true;
  wrap("pushState");
  wrap("replaceState");
  window.addEventListener("popstate", () => pageview());
}
function init(options) {
  if (!options?.endpoint) return;
  cfg = {
    autoPageviews: true,
    includeQuery: false,
    hashRouting: false,
    domain: "",
    trackLocalhost: false,
    ...options
  };
  if (!isBrowser()) return;
  if (!cfg.trackLocalhost && isLocalhost()) {
    cfg = null;
    return;
  }
  if (cfg.autoPageviews) enableAutoPageviews();
  pageview();
}

export { init, isLocalhostHost, pageview, sendBeacon, track };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map